<div class="model-viewer-artefacto" [style]="{ height: height, width: width }">
  <!-- Error messages -->
  <ng-container *ngIf="errorMessages">
    <div *ngFor="let errorMessage of errorMessages">{{ errorMessage }}</div>
  </ng-container>

  <!-- The Google model-viewer -->
  <model-viewer
    [src]="modelFilePath"
    *ngIf="enabled"
    #modelViewer
    ar-scale="fixed"
    shadow-intensity="1"
    bounds="tight"
    enable-pan
    ar
    ar-modes="webxr scene-viewer quick-look"
    camera-controls
    environment-image="neutral"
    autoplay
    style="height: 100%; width: 100%"
    [force-ar]="forceAr"
    tone-mapping="neutral"
    shadow-intensity="1"
  >
    <!-- place a fake hidden button -->
    <button
      *ngIf="hideArButton"
      slot="ar-button"
      style="display: none"
    ></button>
  </model-viewer>
</div>
